import type { TOC } from '@ember/component/template-only';

const DataPerformanceInsightsSvgLowestComponent: TOC<Record<string, never>> = <template>
	<svg width="34" height="30" viewBox="0 0 34 30" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g class="other bars">
			<path
				opacity="0.5"
				d="M31.3037 28.0396H1.69922"
				stroke="#8E929B"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M4 25V6"
				stroke="#8E929B"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M19 25V17"
				stroke="#8E929B"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M9 25V9"
				stroke="#8E929B"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M14 25V6"
				stroke="#8E929B"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M29 25V15"
				stroke="#8E929B"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
		<g class="focused">
			<path
				d="M24 25V18"
				stroke="#E62828"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M27 11H21L24 15L27 11Z"
				stroke="#E62828"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
	</svg>
</template>;

export default DataPerformanceInsightsSvgLowestComponent;
